import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useRef, useState, useEffect } from 'react';

const EllipsisWithTooltip = ({ text, className }) => {
	const divRef = useRef(null);
	const [isOverflowed, setIsOverflowed] = useState(false);

    useEffect(() => {
		const el = divRef.current;
		if (el) {
			setIsOverflowed(el.scrollHeight > el.clientHeight);
		}
	}, [text]);

	const content = (
		<div ref={divRef} className={className}>
			{text}
		</div>
	);

	return isOverflowed ? (
		<OverlayTrigger placement="top" overlay={<Tooltip>{text}</Tooltip>}>
			{content}
		</OverlayTrigger>
	) : (
		content
	);
};
export default EllipsisWithTooltip;
